import { render, staticRenderFns } from "./FormJanelaCargaDescarga.vue?vue&type=template&id=38ad70bc"
import script from "./FormJanelaCargaDescarga.vue?vue&type=script&lang=js"
export * from "./FormJanelaCargaDescarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports